/**
 * Shared Terms & Conditions disclosure for the spin-to-win rewards program
 * -- used on both the authenticated `/account/rewards` page and the public
 * `/earn-with-fun` landing page so the copy only lives in one place. Plain
 * `<details>/<summary>` is accessible by default (keyboard-operable,
 * exposed to assistive tech as a disclosure widget) -- no custom
 * collapsible pattern exists elsewhere in the storefront to match.
 */
export function RewardsTerms() {
  return (
    <details className="rounded-2xl border border-gray-100 bg-white p-4 text-sm text-gray-600">
      <summary className="focus-visible:ring-brand cursor-pointer select-none font-semibold text-gray-900 focus-visible:outline-none focus-visible:ring-2">
        Terms &amp; Conditions
      </summary>
      <div className="mt-3 space-y-2">
        <p>
          The rewards spin wheel is available to signed-in customers only, limited to one spin every 24 hours per
          account. The next eligible spin time is shown on this page and is enforced by our systems, not the device
          clock.
        </p>
        <p>
          Winning a spin issues a discount coupon to your account. Coupons have their own minimum order value,
          maximum discount, and expiry date, shown on the coupon itself, and can only be applied at checkout on
          eligible orders. Coupons are not redeemable for cash, points, or any other equivalent, are non-transferable,
          and cannot be combined with other offers unless stated otherwise at checkout.
        </p>
        <p>
          Spin outcomes are determined by our systems at the time of the spin and are final. We reserve the right to
          modify, suspend, or discontinue the rewards program, or to change spin frequency, prize types, or coupon
          terms, at any time without prior notice, including to prevent misuse or abuse of the program.
        </p>
        <p>
          Participation in the rewards program is subject to our general Terms of Service and Privacy Policy. If you
          believe a spin or coupon was issued in error, contact customer support so we can review your account.
        </p>
      </div>
    </details>
  );
}
